export const isIdentifierColumnKey = (key: string): boolean =>
  key === 'id' || key.endsWith('ID') || key.endsWith('Id')

export const isDateStampColumnKey = (key: string): boolean =>
  key === 'createdAt' || key === 'updatedAt' || key === 'created' || key === 'updated'

export const isExcludedColumnKey = (key: string): boolean =>
  isIdentifierColumnKey(key) || isDateStampColumnKey(key)
